import * as types from './constants'

export const updateVersion = (payload) => ({
  type: types.UPDATE_VERSION,
  payload,
})
